import { createAsyncThunk } from "@reduxjs/toolkit";
import CourseApi from "api/CourseApi";

export const fetchCourse = createAsyncThunk(
  "fetchCourse",
  ({ companyId, shopId }: { companyId: number; shopId: number }) =>
    CourseApi.fetchCourse(companyId, shopId)
);
